module.exports = __webpack_public_path__ + "img/2.a528572b.png";